import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Analytics from "./components/Analytics";
import Resources from "./components/Resources";
import Expertises from "./components/Expertises";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import AboutUs from "./components/AboutUs";
import DataAnalysis from "./components/expertises/DataAnalysis";
import BigDataCloud from "./components/expertises/BigDataCloud";
import SoftwareDevelopment from "./components/expertises/SoftwareDevelopment";
import Formation from "./components/expertises/Formation";
import JobAnnonce from "./components/jobAnnonce";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <div
          className="App overflow-x-hidden"
          style={{
            overflowX: "hidden",
            width: "100%",
            maxWidth: "100vw",
          }}
        >
          <Navbar />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero id="hero" />
                  <Resources id="resources" />
                  <Expertises id="expertises" />
                  <AboutUs id="a-propos-de-nous" />
                  <Analytics id="analytics" />
                  <Projects id="projects" />
                </>
              }
            />
            <Route path="/expertises" element={<Expertises />} />
            <Route path="/a-propos-de-nous" element={<AboutUs />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/expertises/analyse-donnees" element={<DataAnalysis />} />
            <Route path="/expertises/big-data" element={<BigDataCloud />} />
            <Route path="/expertises/developpement-logiciel" element={<SoftwareDevelopment />} />
            <Route path="/expertises/formation" element={<Formation />} />
            <Route path="/nous-rejoindre" element={<JobAnnonce />} />
            <Route
              path="*"
              element={
                <div className="flex items-center bg-white justify-center h-screen">
                  <div className="bg-[#b5dd22] text-center px-5 py-5 w-64 text-lg flex items-center justify-center">
                    La page recherchée est encore au développement ou n'existe pas
                  </div>
                </div>
              }
            />
          </Routes>
          <Footer id="footer" />
          <ScrollToTopButton />
        </div>
      </Router>
    </I18nextProvider>
  );
}

export default App;
